
import ko from 'rgs-knockout';

import AddressEditorModel from './js/model';
import template from './templates/template.html';

export default AddressEditorModel;

ko.components.register('address-editor', {
	viewModel: AddressEditorModel,
	template: template(),
});
